export interface WhyChooseFeature {
  image: string;
  label: string;
  detail: string;
  span: string;
}

export interface WhyChooseTab {
  phrase: string;
  color: "primary" | "secondary" | "grow";
  content: {
    title: string;
    description: string;
    features: WhyChooseFeature[];
  };
}

// NOTE: New placeholder images needed for social proof slide (tab 2):
// - /placeholder-businesses.jpg (community/multiple buildings)
// - /placeholder-rating.jpg (5 stars visual)
// - /placeholder-global.jpg (map/globe visual)
export const WHY_CHOOSE_TABS: WhyChooseTab[] = [
  {
    phrase: "Designed for business owners like you.",
    color: "primary",
    content: {
      title: "Built for Local Businesses",
      description: "Perfect for business owners who want to streamline operations and grow their customer base.",
      features: [
        { image: "/placeholder-restaurant.jpg", label: "Restaurants & Cafes", detail: "Menu, staff & reviews", span: "row-span-2" },
        { image: "/placeholder-retail.jpg", label: "Retail Stores", detail: "Inventory & customer loyalty", span: "row-span-2" },
        { image: "/placeholder-service.jpg", label: "Service Businesses", detail: "Bookings & scheduling", span: "row-span-2" }
      ]
    }
  },
  {
    phrase: "See measurable results.",
    color: "secondary",
    content: {
      title: "Measurable Results",
      description: "Transform your business with proven outcomes and significant time savings.",
      features: [
        { image: "/placeholder-timesaved.jpg", label: "10+ hours saved", detail: "Weekly time savings", span: "row-span-2" },
        { image: "/placeholder-retention.jpg", label: "25% retention boost", detail: "Customer loyalty increase", span: "row-span-2" },
        { image: "/placeholder-reviews.jpg", label: "3x more reviews", detail: "Collect customer feedback", span: "row-span-2" }
      ]
    }
  },
  {
    phrase: "Future-proof your business.",
    color: "grow",
    content: {
      title: "Ready for What's Next",
      description: "Modernize your operations and prepare for the AI-powered future.",
      features: [
        { image: "/placeholder-paperless.jpg", label: "Go paperless", detail: "Digitize your operations", span: "row-span-2" },
        { image: "/placeholder-ai.jpg", label: "AI-ready", detail: "Automate the mundane", span: "row-span-2" },
        { image: "/placeholder-data.jpg", label: "Data-driven", detail: "Uncover hidden potential", span: "row-span-2" }
      ]
    }
  }
];
